import NewsletterArchiveList from "@/components/newsletter/NewsletterArchiveList";
import NewsletterFeaturedTop3 from "@/components/newsletter/NewsletterFeaturedTop3";
import { useNewsletterPosts } from "@/hooks/use-newsletter-posts";

export default function NewsletterPostList() {
  const { posts, loading, error } = useNewsletterPosts();

  const top3 = posts.slice(0, 3);
  const rest = posts.slice(3);

  return (
    <div className="w-full bg-black">
      {error ? (
        <div className="mx-auto w-[90%] max-w-[100vw] py-8 md:w-[80%]">
          <p className="text-sm text-amber-200/90" role="alert">
            {error}
          </p>
        </div>
      ) : null}

      {!error && !loading && posts.length === 0 ? (
        <div className="mx-auto w-[90%] max-w-[100vw] py-12 md:w-[80%]">
          <p className="text-sm text-white/55">No posts returned yet.</p>
        </div>
      ) : null}

      <NewsletterFeaturedTop3 posts={top3} loading={loading && !error} />

      {!loading && !error && posts.length > 0 ? (
        <NewsletterArchiveList posts={rest} loading={false} />
      ) : loading && !error ? (
        <NewsletterArchiveList posts={[]} loading />
      ) : null}
    </div>
  );
}
